module.exports = "https://s91588.cdn.ngenix.net/reviews-frontend/_next/static/images/DefaultLogo-bc17dfae66a8752f3834a21ca6de2348.svg";